import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { IconProps } from '../../primitives/types.js';

interface StarSpec {
  readonly cx: number;
  readonly cy: number;
  readonly r: number;
  readonly delay: number;
}

const STARS: readonly StarSpec[] = [
  { cx: 4, cy: 3.5, r: 0.35, delay: 0 },
  { cx: 3, cy: 6, r: 0.28, delay: 0.7 },
  { cx: 5.5, cy: 8.5, r: 0.32, delay: 1.3 },
];

/** Moon — crescent with three softly twinkling stars.
 *  Minimal motion — appropriate for a "dark mode" affordance. */
export function IcnMoon(props: IconProps): ReactNode {
  const reduced = useReducedMotion();
  return (
    <Svg {...props} iconName="moon">
      <path d="M13 9.5A5.5 5.5 0 1 1 6.5 3a4.5 4.5 0 0 0 6.5 6.5z" />
      {!reduced && (
        <g fill="currentColor" stroke="none">
          {STARS.map((s) => {
            const key = `${String(s.cx)}-${String(s.cy)}`;
            const begin = `${String(s.delay)}s`;
            return (
              <circle key={key} cx={s.cx} cy={s.cy} r={s.r} opacity="0">
                <animate
                  attributeName="opacity"
                  values="0;0.95;0.3;0"
                  keyTimes="0;0.12;0.22;0.35"
                  dur="2.6s"
                  begin={begin}
                  repeatCount="indefinite"
                />
              </circle>
            );
          })}
        </g>
      )}
    </Svg>
  );
}
